import type { MenuProps } from 'antd';
import { Menu, Popover } from 'antd';
import { useNavigate } from 'react-router-dom';
import Paths from '@/configs/router/paths';
import { useSessionContext } from '@/contexts/session/context';
import Dialog from '@/components/dialog';
import SettingsIcon from '@/assets/images/personalMenu/settings.svg?react';
import LogoutIcon from '@/assets/images/personalMenu/logout.svg?react';
import styles from './index.module.scss';
import EditIcon from './images/edit.svg?react';
import IDIcon from './images/id.svg?react';

const PersonalCenter = ({ children }: { children: React.ReactNode }) => {
  const {
    logout,
    session: { user },
  } = useSessionContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const items: MenuProps['items'] = [
    // {
    //   type: 'divider',
    // },
    {
      key: Paths.SETTINGS_PATH,
      label: 'Settings',
      icon: <SettingsIcon />,
      onClick: () => {
        navigate(Paths.SETTINGS_NOTIFICATIONS);
      },
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutIcon />,
      onClick: () => {
        Dialog({
          centered: true,
          title: <div>Log out?</div>,
          confirmText: 'Logout',
          content:
            'Logout will not delete any data. You can still log in with this account.',
          onConfirm: () => {
            logout();
          },
        });
      },
    },
  ];

  const handleClick: MenuProps['onClick'] = (e) => {
    setSelectedKeys([e.key]);
  };

  useEffect(() => {
    setSelectedKeys([location.pathname.split('/').slice(0, 3).join('/')]);
  }, [location.pathname]);

  return (
    <Popover
      placement="rightTop"
      arrow={false}
      classNames={{ root: styles.popoverWrapper }}
      content={
        <div className={styles.content}>
          <div className={styles.userInfo}>
            <MyAvatar
              size="large"
              className={styles.avatar}
              src={user?.avatar as string}
            ></MyAvatar>
            <div className={styles.info}>
              <div className={styles.top}>
                <div className={styles.name}>{user?.name}</div>
                <EditIcon />
              </div>
              <div className={styles.bottom}>
                <div className={styles.id}>@{user?.username}</div>
                <div className={styles.label}>
                  <IDIcon />
                </div>
              </div>
            </div>
          </div>
          <Menu items={items} selectedKeys={selectedKeys} onClick={handleClick} />
        </div>
      }
    >
      {children}
    </Popover>
  );
};

export default PersonalCenter;
